import { Reducer } from "redux";

import {
    STROLLER_REVIEW_PHOTO_FETCH_FAILURE,
    STROLLER_REVIEW_PHOTO_FETCH_REQUEST,
    STROLLER_REVIEW_PHOTO_FETCH_SUCCESS,
    StrollerReviewPhotoFetchFailureAction,
    StrollerReviewPhotoFetchRequestAction,
    StrollerReviewPhotoFetchSuccessAction,
} from "@/mk2/apps/strollers/containers/StrollerReviewPhoto/StrollerReviewPhoto.actions";
import { tupdate } from "@/mk2/helpers/types";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface StrollerReviewPhotoState {
    loadingState: LoadingState;
    strollerId: number | null;
    strollerReviewId: number | null;
}

export const initialStrollerReviewPhotoState = {
    loadingState: LoadingState.INIT,
    strollerId: null,
    strollerReviewId: null,
    strollerPendingReviewIds: [],
    strollerAlikeStrollerIds: [],
};

export interface StrollersReviewsPhotosState {
    [strollerSlug: string]: StrollerReviewPhotoState;
}

const initialStrollersReviewsPhotosState: StrollersReviewsPhotosState = {};

declare type StrollersReviewsPhotosReducerAction =
    | StrollerReviewPhotoFetchRequestAction
    | StrollerReviewPhotoFetchSuccessAction
    | StrollerReviewPhotoFetchFailureAction;

export const strollersReviewsPhotosReducer: Reducer<StrollersReviewsPhotosState> = (
    state = initialStrollersReviewsPhotosState,
    action: StrollersReviewsPhotosReducerAction,
) => {
    switch (action.type) {
        case STROLLER_REVIEW_PHOTO_FETCH_REQUEST:
        case STROLLER_REVIEW_PHOTO_FETCH_FAILURE: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                [strollerSlug]: tupdate(state[strollerSlug] || initialStrollerReviewPhotoState, {
                    loadingState: loadingState(undefined, action),
                }),
            });
        }

        case STROLLER_REVIEW_PHOTO_FETCH_SUCCESS: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                [strollerSlug]: tupdate(state[strollerSlug] || initialStrollerReviewPhotoState, {
                    loadingState: loadingState(undefined, action),
                    strollerId: action.response.result.stroller,
                    strollerReviewId: action.response.result.strollerReviews[0],
                }),
            });
        }

        default:
            return state;
    }
};
